module.exports = __webpack_public_path__ + "img/4image-1.721139c4.png";